

const { createSlice,  } = require("@reduxjs/toolkit");

const initialState = {
    search: "",
    filter:""
   
};

// async thunk


const filterSlice = createSlice({
    name: "filterSlice",
    initialState,
    reducers:{
        searching:(state, action)=>{
            state.search = (action.payload);
        },
        filtering:(state, action)=>{
            state.filter = (action.payload);
        },
    }
   
});

export default filterSlice.reducer;
export const {searching ,filtering} = filterSlice.actions;